
{
  "fr": {
    "configuratorAddToCartModal": {
      "title": {
        "isLoading": "Ajout au panier en cours…",
        "success": "Votre produit a bien été ajouté"
      },
      "action": {
        "continue": "Continuer mes achats",
        "goToCart": "Accéder au panier",
        "continueCustomOrder": "Poursuivre en BO"
      }
    }
  }
}
